import { render, staticRenderFns } from "./SignForProducts.vue?vue&type=template&id=4e147c07"
import script from "./SignForProducts.vue?vue&type=script&lang=js"
export * from "./SignForProducts.vue?vue&type=script&lang=js"
import style0 from "./SignForProducts.vue?vue&type=style&index=0&id=4e147c07&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports